import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import Helper from '../../Utils/Helper';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { Select, Form, InputNumber, Switch, Alert } from 'antd';
import {Button} from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import styles from './CustomerRateStyles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { BsPlusCircleDotted } from "react-icons/bs";
import { BiSolidMinusCircle } from "react-icons/bi";
import DynamicTimeRangeAddition from '../../Admin/Locations/DynamicTimeRangeAddition';
import DynamicRanges from '../../Admin/Locations/DynamicTimeRanges';
import { toast, ToastContainer } from 'react-toastify';

const CustomerRateView = (props) => {


    const [loading, setLoading] = useState(false);
    const [propsLoading, setProprLoading] = useState(true);
    const [permissions, setPermissions] = useState([])
    const [customerLocations, setCustomerLocations] = useState([])
    const [filterLocation, setFilterLocation] = useState(null);
    const [rateType, setRateType] = useState(null)
    const [chargerData, setChargerData] = useState([])
    const [chargerDynamicRate, setChargerDynamicRate] = useState([])
    const [normalRate, setNormalRate] = useState(null)
    const [isDynamicRateAddFieldVisible, setIsDynamicRateAddfieldVisible] = useState(false)
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [showAlert, setShowAlert] = useState(false)

    const [locationLoading, setLocationLoading] = useState(true)

    const checkCustomerPermissions = async () => {
        let permissionsVar = [];

        permissionsVar = Helper.checkCustomerPermissions(props.userGroups);
        setPermissions(permissionsVar);
        console.log("permissions", permissionsVar)
    }

    const getCustomerLocations = async () => {
        try {
            setLocationLoading(true)
            const res = await BreathAPIs.getDashboardFilterLocations()
            console.log("customer lc", res)
            let locations = res.data.locations.filter(loc => {
                return loc.locationType !== "PUBLIC"
            })
            setCustomerLocations(locations)
            setFilterLocation(locations[0]._id)
        } catch (error) {
            console.log("Error in getting customer locations", error)
        }finally{
            setLocationLoading(false)
        }
    }

    const getChargerData = async () => {
        try {
            setLocationLoading(true)
            const res = await BreathAPIs.customerChargerList(filterLocation);
            console.log("charger get api response: ", res.data.chargers);
            setChargerData(res.data.chargers);
            setNormalRate(res.data.chargers[0].rate.price_components.price)
            setSelectedLocation(res.data.chargers[0].location)
            setRateType(res.data.chargers[0].rateType)
            // setLocationData(prev => ({ ...prev, normalRate: res.data.chargers[0]?.rate.price_components.price, taxAmount: res.data.chargers[0]?.rate.price_components.tax }))
            // // Directly use the fetched data to set chargerDynamicRate
            if (res.data.chargers[0]?.dynamicRates) {
                setChargerDynamicRate(res.data.chargers[0].dynamicRates);
            } else {
                setChargerDynamicRate([]); // Ensure it's an empty array if no rates exist
            }
        } catch (error) {
            console.error("Error fetching charger data:", error);
        }finally{ 
            setLocationLoading(false)
        }
    };
    useEffect(() => {
        if (filterLocation) {
            getChargerData()
        }
    }, [filterLocation])

    useEffect(() => {
        // setProprLoading(true)
        // fetchUserData();
        // setUserNotFoundAlert(false)
        getCustomerLocations()
    }, []);

    useEffect(() => {
        const init = async () => {
            setProprLoading(true);
            await checkCustomerPermissions();
            setProprLoading(false);
        };
        init();
    }, []);

    const changeChargerRateType = (checkedVal) => {
        setRateType(checkedVal ? 'dynamic' : 'fixed');
    };
    const getUpdatedDynamicRates = (updatedDynamicRates) => {
        console.log("updated dynamic rates: ", updatedDynamicRates)
        setChargerDynamicRate(updatedDynamicRates)
    }

    const updateChargerRate = async () => {
        try {
            if(rateType === 'dynamic' && chargerDynamicRate.length === 0){
                setShowAlert(true)
                return;
            }
            setLoading(true)
            const res = await BreathAPIs.updateChargerRate(filterLocation, chargerDynamicRate, rateType, normalRate);
            console.log("charger update api response: ", res);
            if(res.status === 200){
                toast.success("Charger rate updated successfully");
            }else{
                toast.error("something went wrong")
            }
            // setChargerData(res.data.chargers);
        } catch (error) {
            // console.error("Error updating charger rate:", error.response.data.errors);
            toast.error(error.response.data.errors.msg)
        }finally{
            setLoading(false)
        }
    };


    return (
        <Container>
            <ToastContainer />
            {propsLoading ?
                (<div className={styles.spinner}>
                    <FontAwesomeIcon icon={faBolt} size="3x" />
                </div>)
                : (permissions.includes('rateControll') ?
                    <>
                        <div>
                            <Select
                                showSearch
                                maxTagCount={3}
                                disabled={locationLoading}
                                // mode='multiple'
                                // defaultValue="Select Location"
                                placeholder={'Select Location'}
                                style={{ width: '100%' }}
                                value={filterLocation}
                                onChange={(value) => { setFilterLocation(value) }}
                                //onSearch={onSearch}
                                // allowClear
                                options={customerLocations.map(element => ({
                                    value: element._id,
                                    label: element.locationName
                                }))}
                                onClear={() => setFilterLocation(null)}
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase()) // Custom filtering logic
                                }
                            />
                        </div>


                        {(filterLocation === null || filterLocation === undefined) && !propsLoading && !locationLoading && !loading  && <div className={styles['noLocationSelected']}>
                            <p>Please Select a location</p>
                        </div>}

                        {(filterLocation !== null && filterLocation !== undefined) &&
                            <div>
                                {/* <p>selectedLocation: {filterLocation}</p>
                            <p>normalRate: {normalRate}</p>
                            <p>chargerDynamicRate: {chargerDynamicRate}</p> */}
                                

                                {
                                    locationLoading ? (
                                        <div className={`${styles['form-div']}`}>
                                            <div className={`placeholder-glow`} >
                                                <span className="placeholder col-12" style={{height: '40px', color: '#ddd', marginBottom: '10px'}}></span>
                                                </div>
                                                <div className={`placeholder-wave`} >
                                                <span className="placeholder col-12"  style={{height: '70px', color: '#ddd'}}></span>
                                                </div>
                                            {/* <p className={`card-text placeholder-wave`}><span className="placeholder col-12"></span></p> */}
                                            {/* <p>loading...</p> */}
                                            {/* <FontAwesomeIcon icon={faBolt} size="3x" /> */}
                                        </div>
                                    ) : 
                                    <div className={styles['form-div']}>
                                {/* <h6> Rate Details</h6> */}
                                    
                                    <Form layout="vertical">
                                        <div className={styles['normal-rate-div']}>
                                        <Form.Item label="Normal Energy Rate (per kWh)">
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                min={0}
                                                value={normalRate}
                                                onChange={(value) => {
                                                    setNormalRate(value)
                                                }}
                                                disabled={chargerData.length === 0}
                                            />
                                        </Form.Item>
                                        </div>
                                    


                                    <div className={styles.DynamicRateContainer}>
                                        {showAlert && <div className='alert-div'> <Alert
                                                                    message="Please add at least one dynamic rate."
                                                                    type="warning"
                                                                    showIcon
                                                                    closable
                                                                    onClose={() => setShowAlert(false)}
                                                                />
                                                                </div>}
                                        <Form.Item label={`Dynamic Rate ( ${selectedLocation?.timezone} )`} valuePropName="checked">
                                            <div className={styles.dynamicRatesDiv}>
                                                <Switch
                                                    checked={rateType === 'dynamic'}
                                                    onChange={(checked) => changeChargerRateType(checked)}
                                                />
                                                {!isDynamicRateAddFieldVisible ? (
                                                    <BsPlusCircleDotted
                                                        className={`${styles.dynamicRateAddBtn} ${isDynamicRateAddFieldVisible ? styles.hideIcon : ''}`}
                                                        onClick={() => { setIsDynamicRateAddfieldVisible(!isDynamicRateAddFieldVisible); }}
                                                    />
                                                ) : (
                                                    <BiSolidMinusCircle
                                                        className={`${styles.dynamicRateAddBtn} ${!isDynamicRateAddFieldVisible ? styles.hideIcon : ''}`}
                                                        onClick={() => { setIsDynamicRateAddfieldVisible(!isDynamicRateAddFieldVisible); }}
                                                    />
                                                )}
                                            </div>
                                        </Form.Item>
                                        {isDynamicRateAddFieldVisible && <div className={styles.dynamicRateAdditionDiv}><DynamicTimeRangeAddition dynamicRanges={chargerDynamicRate} setDynamicRanges={setChargerDynamicRate} setIsDynamicRateAddfieldVisible={setIsDynamicRateAddfieldVisible} selLocation={selectedLocation} sharedFieldVisible={false} /></div>}
                                        {/* {console.log("rate type while calling dynamicRates component", rateType)}
                                                {console.log(chargerDynamicRate)} */}
                                        {rateType === "dynamic" && chargerDynamicRate && <DynamicRanges dynamicRanges={chargerDynamicRate} setDynamicRanges={setChargerDynamicRate} selLocation={selectedLocation} getUpdatedDynamicRanges={getUpdatedDynamicRates} sharedFieldVisible={false} />}
                                    </div>

                                    <div className={styles['button-div']}>
                                        <Button style={{ width: "90%" }} disabled={loading} onClick={() => updateChargerRate()}> {loading ?<> <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Updating...</> : "Update"} </Button>
                                    </div>
                                    </Form>
                                </div>}


                            </div>}
                    </>


                    :

                    (!loading && <div className={styles['restricted']}>Restricted area !</div>)
                )

            }
        </Container>
    )
}

CustomerRateView.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string,
    customerLocation: PropTypes.array,
    userId: PropTypes.string
};

const mapStateToProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null,
    userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : null,
    customerLocations: state.auth && state.auth.user ? state.auth.user.customerLocation : null,
    userId: state.auth && state.auth.user ? state.auth.user._id : null

});


export default connect(mapStateToProps, {})(CustomerRateView);